import './src/styles/global.css';
import './node_modules/semantic-ui-css/semantic.min.css';
import { setRbSourceFromUTM } from './src/utils/sourceTracking';

export const onClientEntry = () => {
	setRbSourceFromUTM();
};

export const onRouteUpdate = ({ location, prevLocation }) => {
	// Re-run source tracking on route changes to handle UTM parameters
	setRbSourceFromUTM();

	// Set up click handlers for internal links to preserve UTM parameters
	if (typeof window !== 'undefined') {
		setupLinkTracking();
	}
};

// Function to set up automatic link tracking
const setupLinkTracking = () => {
	// Remove existing listeners to prevent duplicates
	const existingLinks = document.querySelectorAll('a[data-utm-tracked="true"]');
	existingLinks.forEach(link => {
		link.removeAttribute('data-utm-tracked');
	});

	// Add click handlers to all internal links
	const links = document.querySelectorAll('a[href^="/"], a[href^="./"], a[href^="../"]');

	links.forEach(link => {
		if (!link.getAttribute('data-utm-tracked')) {
			link.setAttribute('data-utm-tracked', 'true');

			const originalHref = link.getAttribute('href');
			if (originalHref && !originalHref.includes('utm_') && !originalHref.includes('rb=')) {
				// Update href to include UTM parameters for internal links
				const { getUpdatedRbInternalLink } = require('./src/utils/sourceTracking');
				const updatedHref = getUpdatedRbInternalLink(originalHref);
				link.setAttribute('href', updatedHref);
			}
		}
	});
};